import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import { DispoAcceptBookingMutationResponse } from "@/Domains/DispositionManagement/Mutations/__generated__/DispoAcceptBookingMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    id: string,
    onCompleted: (error: Error | null, result?: string | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation DispoAcceptBookingMutation($id: String!) {
                acceptBooking(id: $id) {
                    bookingId
                }
            }
        `,
        variables: {
            id: id,
        },
        onCompleted(result) {
            const res = result as DispoAcceptBookingMutationResponse;
            const bookingId: string | null = res.acceptBooking.bookingId;

            if (bookingId) {
                onCompleted(null, bookingId);
                return;
            }

            throw new BaseError(
                "DispoAcceptBookingMutation failed with an unexpected Error",
                {
                    context: {
                        bookingId: id,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
